<!-- 下拉组件 -->
 <template>
  <div 
    class="custom-dropdown" 
    @mouseenter="openDropdown"
    @mouseleave="closeDropdown"
  >
    <!-- 触发区域 -->
    <div class="dropdown-trigger">
      <span class="trigger-text">{{ text }}</span>
      <span class="arrow" :class="{ 'arrow-up': isOpen, 'arrow-down': !isOpen }">
        <el-icon><ArrowDown /></el-icon>
      </span>
    </div>

    <!-- 下拉菜单 -->
    <transition name="dropdown">
      <div v-show="isOpen" class="dropdown-menu">
        <div 
          v-for="(item, index) in menuItems"  
          :key="index"
          class="menu-item"
          :class="[`wui-hover-color-${themeColor}`]"
          @click="handleItemClick(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ArrowDown } from '@element-plus/icons-vue'

const props = defineProps({
  text: {
    type: String,
    default: '下拉菜单'
  },
  menuItems: {
    type: Array,
    default: () => [
      { label: '选项一', value: '1' },
      { label: '选项二', value: '2' },
      { label: '选项三', value: '3' }
    ]
  },
  themeColor: {
    type: String,
    default: 'blue'
  }
})

const emit = defineEmits(['item-click'])

const isOpen = ref(false)
let closeTimer = null

const openDropdown = () => {
  if (closeTimer) {
    clearTimeout(closeTimer)
    closeTimer = null
  }
  isOpen.value = true
}

const closeDropdown = () => {
  closeTimer = setTimeout(() => {
    isOpen.value = false
  }, 200) // 延迟关闭，避免鼠标移动时意外关闭
}

const handleItemClick = (item) => {
  emit('item-click', item)
  isOpen.value = false
}
</script>

<style scoped lang="less">
.custom-dropdown {
  position: relative;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  color: #121212;
  /* border-radius: 8px; */
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3); */
}

.dropdown-trigger:hover {
  /* box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4); */
}

.trigger-text {
  font-weight: 400;
  font-size: 16px;
}

.arrow {
  font-size: 10px;
  transition: transform 0.3s ease;
  display: inline-block;
}

.arrow-up {
  transform: rotate(180deg);
}

.arrow-down {
  transform: rotate(0deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: -20px;
  margin-top: 12px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  z-index: 1000;
  overflow: hidden;
  border: 1px solid #e1e5e9;
}

.menu-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
  color: #2d3748;
  border-bottom: 1px solid #f7fafc;
  padding: 14px 32px 14px 32px;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  color: white;
}

/* 动画效果 */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
  transform-origin: top center;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>